import { render, staticRenderFns } from "./PageLoading.vue?vue&type=template&id=31ea1dde&scoped=true&"
import script from "./PageLoading.vue?vue&type=script&lang=ts&"
export * from "./PageLoading.vue?vue&type=script&lang=ts&"
import style0 from "./PageLoading.vue?vue&type=style&index=0&id=31ea1dde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ea1dde",
  null
  
)

export default component.exports